import React from "react";
import Workbook from 'react-excel-workbook'

export default class ExelBudzet1 extends React.Component {
    constructor(props) {
        super();
    }

    render() {
        let { data } = this.props;
        return (
            <Workbook filename="Budzet.xlsx" element={<button type="button" class="btn btn-light m-2 float-right"><i class="far fa-file-excel"></i> Export Excel</button>}>
                <Workbook.Sheet data={data} name="Budzet">
                    <Workbook.Column label="Dział" value="Dzial"/>
                    <Workbook.Column label="Rozdział" value="Rozdzial"/>
                    <Workbook.Column label="Paragraf" value="Paragraf"/>
                    <Workbook.Column label="Pozycja" value="Pozycja"/>
                    <Workbook.Column label="Rodzaj" value="Rodzaj"/>
                    <Workbook.Column label="Wydzial" value="Wydzial"/>
                    <Workbook.Column label="Opis" value="Opis"/>
                    <Workbook.Column label="Przed" value="Przed"/>
                    <Workbook.Column label="Po" value="Po"/>
                    <Workbook.Column label="poWniosku" value="poWniosku"/>
                    <Workbook.Column label="Zmiany" value="Zmiany"/>
                    <Workbook.Column label="Wniosek" value="Wniosek"/>
                </Workbook.Sheet>
            </Workbook>
        );
    }
}